<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left2Data: {
      type: Object,
      default: () => {},
    }
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.left2Data,props.name,props.color);
      
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init() {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);
   var captions = ['2020', '2021', '2022', '2023'];
   var values = ['2.3', '1.0', '-1.2', '3.1'];

    this.state.chart.setOption({
          tooltip: {
            trigger: "axis",
            axisPointer: {
               type: 'none'
            },
            position: function (point, params, dom, rect, size) { // 提示框位置
               let x = 0;
               let y = 0;
               if (point[0] + size.contentSize[0] + 10 > size.viewSize[0]) {
                  x = point[0] - size.contentSize[0] - 10
               } else {
                  x = point[0] + 10
               }
               if (point[1] + size.contentSize[1] + 10 > size.viewSize[1]) {
                  y = point[1] - size.contentSize[1] - 10
               } else {
                  y = point[1] + 10
               }
               return [x, y];
            },
            formatter: params => {
               console.log(params)
               const {
                  name, 
                  data,
               } = params[0];
               return `
                  <div style="font-size: 14px;font-family: Source Han Sans CN-Medium;font-weight: 500;color: #FFFFFF;margin-bottom:12px;">${name}</div>
                  <div style="font-size: 14px;font-family: Source Han Sans CN-Medium;font-weight: 500;color: #FFFFFF;margin-bottom:4px;">销售金额${data} 元</div>
               `
               
            },
            extraCssText: 'opacity: 0.8;background-color:#050F1B;padding:16px;box-shadow: 1px 6px 15px 1px rgba(0,0,0,0.13);border-radius: 4px;filter: blur(undefinedpx);border:none;'
         },
         grid: {
            left: 20,
            top: 15,
            right: 10,
            bottom: 20,
            contentLabel: true
         },
         xAxis: {
            type: 'category',
            data: captions,
            // boundaryGap:false,
            axisTick: {
               show: false //隐藏X轴刻度
            },
            axisLine: {
               show: true,
               onZero:false,
               lineStyle: {
                  color: "#024349"
               }
            },
            axisLabel: {
               show: true,
               textStyle: {
                  color:  'rgba(255,255,255,.65)', 
                  fontSize: 13,
               }
            },
         },
         yAxis: [{
            type:'value',
            name: "%",
            axisLabel: {
               color: 'rgba(255,255,255,.65)',
               textStyle: {
                  fontSize: 12
               },
            },
            axisLine: {
               show: true,
               lineStyle: {
                  color: '#024349',
               }
            },
            axisTick: {
               show: false
            },
            splitLine: {
               show:false,
               lineStyle: {
                  color: 'rgba(223, 223, 223, 1)',
                  type: "dashed",
               }
            }
         }],
         series: [{
            type: 'line',
            data: values,
            symbolSize: 4, //标记的大小
            symbol: 'circle',
            // areaStyle: {
            //    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            //       offset: 0,
            //       color: 'rgba(116,160,249,0.15)' // 0% 处的颜色
            //    }, {
            //       offset: 1,
            //       color: 'rgba(29,63,120,0)' // 100% 处的颜色
            //    }], false),
            // },

            itemStyle: {
               //折线拐点标志的样式
               borderColor: "#057551",
               borderWidth: 5,
		            color: new echarts.graphic.LinearGradient(0, 0, 0, 1,[
		    			{
		            offset:1, color: '#057551' // 0% 处的颜色
		            }, 
                  {
		               offset:0.45, color: '#fff' 
		            },{
		               offset:0.1, color: '#057551'
		            },  
                  {
		               offset:0.4, color: '#057551' 
		            },
		            {
		               offset:0, color: '#057551' // 100% 处的颜色
		            }
		            ]
		         ),  //背景渐变色 
            },
            smooth: 0.4,
            emphasis: {
               scale:1.5
            }
         }]
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
